import { createContext, useContext, useState } from "react";

const LanguageContext = createContext({ lang: "de", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("hb_lang") || "de"; } catch { return "de"; }
  });

  const updateLang = (l) => {
    setLang(l);
    try { localStorage.setItem("hb_lang", l); } catch {}
    // Update html lang attribute for SEO
    document.documentElement.lang = l === "it" ? "it" : "de";
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: updateLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
